import ActualCarrierForm from '@components/organisms/forms/ActualCarrierForm';
import AddressForm from '@components/organisms/forms/AddressForm';
import BirthDayForm from '@components/organisms/forms/BirthDayForm';
import ActualBonusForm from '@components/organisms/forms/BonusForm';
import ConfirmQuoteForm from '@components/organisms/forms/ConfirmQuoteForm';
import ContactForm from '@components/organisms/forms/ContactForm';
import CPFForm from '@components/organisms/forms/CPFForm';
import GarageForm from '@components/organisms/forms/GarageForm';
import HouseTypeForm from '@components/organisms/forms/HouseType';
import InstallmentsForm from '@components/organisms/forms/InstallmentsForm';
import PlateForm from '@components/organisms/forms/LicencePlateForm';
import MainConductorForm from '@components/organisms/forms/MainConductorForm';
import ManufacturingYearForm from '@components/organisms/forms/ManufacturingYearForm';
import MaritalStatusForm from '@components/organisms/forms/MaritalStatusForm';
import NameForm from '@components/organisms/forms/NameForm';
import CEPForm from '@components/organisms/forms/OvernightCepForm';
import QuoteTypeForm from '@components/organisms/forms/QuoteTypeForm';
import SchoolParkingForm from '@components/organisms/forms/SchoolParkingForm';
import SexForm from '@components/organisms/forms/SexForm';
import UserIntentForm from '@components/organisms/forms/UserIntentForm';
import VehicleForm from '@components/organisms/forms/VehicleForm';
import VehicleTypeForm from '@components/organisms/forms/VehicleTypeForm';
import VehicleUtilizationForm from '@components/organisms/forms/VehicleUtilizationForm';
import WorkParkingForm from '@components/organisms/forms/WorkParkingForm';
import YoungConductorForm from '@components/organisms/forms/YoungConductorForm';
import ZeroKMForm from '@components/organisms/forms/ZeroKMForm';
import { VehicleType } from '@graphql/generated';
import { Question } from 'types/types';

export const QUOTE_QUESTIONS: Question[] = [
  {
    Form: QuoteTypeForm,
    text: () => (
      <span>
        Olá, eu sou a Laura 👋
        <br />
        Atualmente, você tem seguro para esse veículo?
      </span>
    ),
    id: 'start',
  },

  {
    Form: UserIntentForm,
    text: () => 'Por que você não tem seguro? 🤔',
    id: 'notInsured',
  },

  {
    Form: ActualCarrierForm,
    text: () => <span>Qual a seguradora atual?</span>,
    id: 'carrier',
  },
  {
    Form: ActualBonusForm,
    text: () => 'Qual o número da sua classe de bônus atual?',
    id: 'bonus',
  },
  {
    Form: PlateForm,
    text: () => <span>Qual a placa do veículo?</span>,
    id: 'licencePlate',
  },

  {
    Form: VehicleTypeForm,
    text: () => <span>Qual o tipo?</span>,
    id: 'type',
  },
  {
    Form: VehicleForm,
    text: () => <span>Qual é o veículo?</span>,
    id: 'vehicle',
  },
  {
    Form: ManufacturingYearForm,
    text: () => <span>Qual o ano de fabricação?</span>,
    id: 'manufacturingYear',
  },
  {
    Form: ZeroKMForm,
    text: () => <span>É zero km?</span>,
    id: 'zeroKm',
  },

  {
    Form: CEPForm,
    text: () => <span>Onde o veículo passa a noite?</span>,
    id: 'cep',
  },
  {
    Form: VehicleUtilizationForm,
    text: () => <span>Como você usa o veículo?</span>,
    id: 'utilization',
  },
  {
    Form: HouseTypeForm,
    text: () => <span>Qual o tipo de residência?</span>,
    id: 'houseType',
  },
  {
    Form: GarageForm,
    text: (d) => (
      <span>
        {d?.vehicle?.type === VehicleType.Trucks
          ? 'Quando não está em serviço'
          : 'Na residência'}
        , o veículo fica em qual tipo de garagem?
      </span>
    ),
    id: 'houseParking',
  },
  {
    Form: WorkParkingForm,
    text: () => (
      <span>No trabalho, o veículo fica em qual tipo de garagem?</span>
    ),
    id: 'workParking',
  },
  {
    Form: SchoolParkingForm,
    text: () => (
      <span>Na escola/faculdade, o veículo fica em qual tipo de garagem?</span>
    ),
    id: 'schoolParking',
  },
  {
    Form: CPFForm,
    text: () => <span>Qual seu CPF?</span>,
    id: 'cpf',
  },
  {
    Form: NameForm,
    text: () => <span>Ainda não fomos apresentados. Qual seu nome?</span>,
    id: 'name',
  },
  {
    Form: BirthDayForm,
    text: () => <span>Quando você nasceu?</span>,
    id: 'birthday',
  },
  {
    Form: SexForm,
    text: () => <span>Qual seu sexo?</span>,
    id: 'sex',
  },

  {
    Form: MaritalStatusForm,
    text: () => <span>Qual seu estado civil?</span>,
    id: 'maritalStatus',
  },

  {
    Form: MainConductorForm,
    text: () => <span>Você é o condutor principal?</span>,
    id: 'mainConductor',
  },
  {
    Form: YoungConductorForm,
    text: () => <span>O condutor reside com pessoas entre 17 e 25 anos?</span>,
    id: 'youngCoverage',
  },
  {
    Form: ContactForm,
    text: () => <span>Por último. Quais seus dados de contato?</span>,
    id: 'contact',
  },
];

export const PARTNER_QUESTIONS: Question[] = [
  {
    Form: (props) => <QuoteTypeForm {...props} />,
    text: () => <span>Atualmente, você tem seguro para esse veículo?</span>,
    id: 'start',
  },

  {
    Form: UserIntentForm,
    text: () => 'Por que você não tem seguro? 🤔',
    id: 'notInsured',
  },

  {
    Form: ActualCarrierForm,
    text: () => <span>Qual a seguradora atual?</span>,
    id: 'carrier',
  },
  {
    Form: ActualBonusForm,
    text: () => 'Qual o número da sua classe de bônus atual?',
    id: 'bonus',
  },
  {
    Form: (props) => <PlateForm {...props} />,
    text: () => <span>Qual a placa do veículo?</span>,
    id: 'licencePlate',
  },

  {
    Form: VehicleTypeForm,
    text: () => <span>Qual o tipo?</span>,
    id: 'type',
  },
  {
    Form: VehicleForm,
    text: () => <span>Qual é o veículo?</span>,
    id: 'vehicle',
  },
  {
    Form: ManufacturingYearForm,
    text: () => <span>Qual o ano de fabricação?</span>,
    id: 'manufacturingYear',
  },
  {
    Form: ZeroKMForm,
    text: () => <span>É zero km?</span>,
    id: 'zeroKm',
  },

  {
    Form: CEPForm,
    text: () => <span>Onde o veículo passa a noite?</span>,
    id: 'cep',
  },
  {
    Form: VehicleUtilizationForm,
    text: () => <span>Como você usa o veículo?</span>,
    id: 'utilization',
  },
  {
    Form: HouseTypeForm,
    text: () => <span>Qual o tipo de residência?</span>,
    id: 'houseType',
  },
  {
    Form: GarageForm,
    text: (d) => (
      <span>
        {d?.vehicle?.type === VehicleType.Trucks
          ? 'Quando não está em serviço'
          : 'Na residência'}
        , o veículo fica em qual tipo de garagem?
      </span>
    ),
    id: 'houseParking',
  },
  {
    Form: WorkParkingForm,
    text: () => (
      <span>No trabalho, o veículo fica em qual tipo de garagem?</span>
    ),
    id: 'workParking',
  },
  {
    Form: SchoolParkingForm,
    text: () => (
      <span>Na escola/faculdade, o veículo fica em qual tipo de garagem?</span>
    ),
    id: 'schoolParking',
  },
  {
    Form: (props) => <CPFForm {...props} />,
    text: () => <span>Qual seu CPF?</span>,
    id: 'cpf',
  },
  {
    Form: NameForm,
    text: () => <span>Ainda não fomos apresentados. Qual seu nome?</span>,
    id: 'name',
  },
  {
    Form: BirthDayForm,
    text: () => <span>Quando você nasceu?</span>,
    id: 'birthday',
  },
  {
    Form: SexForm,
    text: () => <span>Qual seu sexo?</span>,
    id: 'sex',
  },

  {
    Form: MaritalStatusForm,
    text: () => <span>Qual seu estado civil?</span>,
    id: 'maritalStatus',
  },

  {
    Form: MainConductorForm,
    text: () => <span>Você é o condutor principal?</span>,
    id: 'mainConductor',
  },
  {
    Form: YoungConductorForm,
    text: () => <span>O condutor reside com pessoas entre 17 e 25 anos?</span>,
    id: 'youngCoverage',
  },
  {
    Form: ContactForm,
    text: () => <span>Por último. Quais seus dados de contato?</span>,
    id: 'contact',
  },
];

export const PROPOSAL_QUESTIONS: Question[] = [
  {
    id: 'installments',
    text: () => 'Escolha a forma de pagamento',
    Form: InstallmentsForm,
  },
  {
    id: 'address',
    text: () => 'Qual seu endereço?',
    Form: AddressForm,
  },

  {
    id: 'confirm',
    text: () => 'Maravilha! Chegou a hora de concluir sua contratação :)',
    Form: ConfirmQuoteForm,
  },
];
